import { AccountSettings } from "../../../../components/AddOns/Accounting/AccountSettings";
import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const AccountSettingsPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Account Settings"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      mainContents={<AccountSettings />}
    />
  );
};
